import {Model} from 'vue-mc';
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class loginModel extends Model {

    defaults() {
        return {
            data: {
                "error": "",
                "message": "",
                "interpreter_name": "",
                "interpreter_email": ""
            }
        }
    }

    routes() {
        return {
            save: 'interpreter/login',
            staffLogin: 'staff/interpreter/confirm_login',
            staffInterpreterLogin: 'staff/interpreter/login',
            changePassword: 'interpreter/password/send_link',
            checkToken: 'interpreter/password/check_token',
            resetPassword: 'interpreter/password/reset',
            checkOTP: 'interpreter/check_otp',
            resendOTP: 'interpreter/resend_otp',
            createErrorLog: 'error_log/create'
        }
    }
}
